import { render } from "./TollFreeDetailsModal.vue?vue&type=template&id=b97940fa&scoped=true"
import script from "./TollFreeDetailsModal.vue?vue&type=script&lang=js"
export * from "./TollFreeDetailsModal.vue?vue&type=script&lang=js"

import "./TollFreeDetailsModal.vue?vue&type=style&index=0&id=b97940fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97940fa"]])

export default __exports__